import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "status"]

  check(event) {
    event.preventDefault()
    const api = event.params.api
    const url = event.params.url
    console.log("Health check triggered for", api, "at", url)

    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = true
      this.buttonTarget.textContent = "Checking..."
    }

    if (this.hasStatusTarget) {
      this.statusTarget.innerHTML = ""
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({ api: api })
    })
      .then(response => response.json())
      .then(data => {
        if (this.hasStatusTarget) {
          const badgeClass = data.status === "ok" ? "badge-success" : "badge-danger"
          this.statusTarget.innerHTML =
            `<span class="badge ${badgeClass} ml-2">${data.message}</span>`
        }
      })
      .catch(err => {
        if (this.hasStatusTarget) {
          this.statusTarget.innerHTML =
            `<span class="badge badge-danger ml-2">Request failed: ${err.message}</span>`
        }
      })
      .finally(() => {
        if (this.hasButtonTarget) {
          this.buttonTarget.disabled = false
          this.buttonTarget.textContent = "Run Health Check"
        }
      })
  }
}
